import
{
    v4 as uuidv4
}
from 'uuid';

import Config from "../Config";
import DataCache from "../resources/data/DataCache";
import MetamodelStore from "../resources/data/MetamodelStore";
import RequestHelper from "./RequestHelper";
import
{
    encode
}
from "base64-arraybuffer";
import { isBasicAuth } from '../_components/oauth/OAuth';
import StateGlobal from '../StateGlobal';

/**
 * Creating json data for JSONTree components
 */
export default class JsonTreeDataCreator
{
    /**
     * Model's objects data
     * @param {Object} aClasses 
     */
    static objectsData = (aClasses, bPreventSorted, bNestedData) =>
    {
        var aMetaClasses = [];
        try
        {
            var aMetaClasses = MetamodelStore.getObjectsByID(aClasses, bPreventSorted);
        }
        catch (err)
        {
            console.error(err);
        }

        Config.getConfig();
        var aJsonRet = {};
        if (typeof aMetaClasses != 'object' || !(Symbol.iterator in Object(aMetaClasses)))
        {
            return aJsonRet;
        }

        for (var i = 0; i < aMetaClasses.length; i++)
        {
            var aMetaClass;
            aMetaClass = aMetaClasses[i];
            if (!aMetaClass)
            {
                break;
            }

            if (!Config.getLangName(aMetaClass))
            {
                console.warn("Object has no correct name.");
                continue;
            }
            var sClassName = Config.getLangName(aMetaClass);
            aJsonRet[sClassName] = {};
            aJsonRet[sClassName]['id_group'] = aMetaClass.id;
            aJsonRet[sClassName]['sName_group'] = aMetaClass.sName;

            aJsonRet[sClassName][Config.strings.jsonTree.objectAttrSectionKey] = null;
            if (Object.hasOwnProperty.call(aMetaClass, 'notebookStructure'))
            {
                aJsonRet[sClassName][Config.strings.jsonTree.objectAttrSectionKey] = JsonTreeDataCreator.notebookData(aMetaClass.notebookStructure, bNestedData);
            }
            aJsonRet[sClassName]['table_popup'] = true;
        }

        return aJsonRet;
    }

    /**
     * Data from model/object notebook
     * @param {Object} aNotebookStructure 
     */
    static notebookData = (aNotebookStructure, bNestedData) =>
    {
        Config.getConfig();
        var aJsonRet = {};
        var aOrder = [];
        if (Object.hasOwnProperty.call(aNotebookStructure, 'childOrder') && typeof aNotebookStructure.childOrder === 'object')
        {
            aOrder = aNotebookStructure.childOrder;
        }
        else if (Object.hasOwnProperty.call(aNotebookStructure, 'children') && typeof aNotebookStructure.children === 'object')
        {
            aOrder = Object.keys(aNotebookStructure.children)
        }
        else
        {
            return aJsonRet;
        }

        if (!Object.hasOwnProperty.call(aNotebookStructure, 'children') || typeof aNotebookStructure.children != 'object')
        {
            return aJsonRet;
        }
        var aChildren = aNotebookStructure.children;

        for (var i = 0; i < aOrder.length; i++)
        {
            if (!Config.getLangName(aChildren[aOrder[i]]))
            {
                console.warn("Chapter has no correct name. ID: " + aOrder[i] + ".");
                continue;
            }
            var sChapterName = Config.getLangName(aChildren[aOrder[i]]);
            aJsonRet[sChapterName] = {};

            aJsonRet[sChapterName] = JsonTreeDataCreator.getNotebookSection(aChildren[aOrder[i]]);
            if (!aJsonRet[sChapterName])
            {
                continue;
            }

            if (0 < Object.keys(aJsonRet[sChapterName]).length && sChapterName)
            {
                aJsonRet[sChapterName] = Object.assign(
                {
                    'chapter_name': sChapterName
                }, aJsonRet[sChapterName]);
            }
        }

        if (bNestedData)
        {
            let aRelations = {};
            aRelations[Config.strings.jsonTree.nestedData.incomingKey] = {};
            aRelations[Config.strings.jsonTree.nestedData.outgoingKey] = {};

            let bInterrefOnly = true;
            if (localStorage["ado_version"])
            {
                let aAdoVersion = JSON.parse(localStorage["ado_version"]);
                if (
                    aAdoVersion &&
                    aAdoVersion.hasOwnProperty("productVersion") && typeof aAdoVersion.productVersion === "string" &&
                    aAdoVersion.hasOwnProperty("productName") && typeof aAdoVersion.productName === "string"
                )
                {
                    const aVersion = aAdoVersion.productVersion.split(".");
                    if ((aAdoVersion.productName.includes("ADONIS") && parseInt(aVersion[0]) >= 13) || (aAdoVersion.productName.includes("ADOIT") && parseInt(aVersion[0]) >= 14))
                    {
                        bInterrefOnly = false;
                    }
                }
            }

            let aEps = MetamodelStore.getInstance().getEntityEpRel(aNotebookStructure.id, null, bInterrefOnly);


            let aEpsIn = aEps.filter((aEp) =>
            {
                return aEp.endpoint.direction === "INCOMING";
            });
            let aEpsOut = aEps.filter((aEp) =>
            {
                return aEp.endpoint.direction === "OUTGOING";
            });

            const addItemToContainer = (aEp) =>
            {

                const sRelKey = (aEp.endpoint.direction === "OUTGOING") ? Config.strings.jsonTree.nestedData.outgoingKey : Config.strings.jsonTree.nestedData.incomingKey;
                const sRelName = Config.getLangName(aEp.relation);

                if (aRelations && aRelations.hasOwnProperty(sRelKey) && aRelations[sRelKey].hasOwnProperty(sRelName))
                {
                    let aTmp = aRelations[sRelKey][sRelName];
                    aRelations[sRelKey][sRelName.concat(" (", aEp.relation.sName, ")")] = {
                        sName: aEp.relation.sName,
                        direction: aEp.endpoint.direction
                    };
                    aRelations[sRelKey][sRelName.concat(" (", aTmp.sName, ")")] = aTmp;
                    delete aRelations[sRelKey][sRelName];
                }
                else
                {
                    aRelations[sRelKey][sRelName] = {
                        sName: aEp.relation.sName,
                        direction: aEp.endpoint.direction,
                    };
                }
            }

            aEpsIn.forEach(aEp =>
            {
                addItemToContainer(aEp);
            });
            aEpsOut.forEach(aEp =>
            {
                addItemToContainer(aEp);
            });

            if (
                0 < Object.keys(aRelations[Config.strings.jsonTree.nestedData.outgoingKey]).length ||
                0 < Object.keys(aRelations[Config.strings.jsonTree.nestedData.incomingKey]).length
            )
            {
                if(StateGlobal._currentBradCrumbs.length === 0){
                    aJsonRet["⇢ "+Config.strings.jsonTree.nestedData.relationsKey] = aRelations;
                }
            }
        }

        return aJsonRet;
    }

    /**
     * Fetch data from specific section of notebook. May be chapter or "subchapter"
     * @param {Object} aSection 
     * @returns 
     */
    static getNotebookSection = (aSection) =>
    {
        var aOrder = [];
        if (Object.hasOwnProperty.call(aSection, 'childOrder') && typeof aSection.childOrder === 'object')
        {
            aOrder = aSection.childOrder;
        }
        else if (Object.hasOwnProperty.call(aSection, 'children') && typeof aSection.children === 'object')
        {
            aOrder = Object.keys(aSection.children)
        }
        else
        {
            console.warn("Provided notebook content is incorrenct.");
            return null;
        }

        var aDataToRet = {};
        var aSectionItems = aSection.children;

        for (var j = 0; j < aOrder.length; j++)
        {
            var aItem = aSectionItems[aOrder[j]];
            // console.log('aItem',aItem.sName)
            // console.log('aItem incoming',aItem.incoming)
            var sEntityName = Config.getLangName(aItem);
            if (!sEntityName)
            {
                console.warn("Notebook item has no correct name. ID: " + aOrder[j] + ".");
                continue;
            }

            if (!Object.hasOwnProperty.call(aItem, 'children'))
            {

                aDataToRet[sEntityName] = {
                    'sName': aItem.sName,
                };

                if (Object.hasOwnProperty.call(aItem, 'type'))
                {
                    switch (aItem.type)
                    {
                        case 16:
                            aDataToRet[sEntityName]['sType'] = "ATTR";
                            aDataToRet[sEntityName]['ctrlType'] = aItem.ctrlType;
                            break;
                        case 32:
                            aDataToRet[sEntityName]['sType'] = "REL";
                            aDataToRet[sEntityName]['isIncomingRel'] = aItem.incoming;
                            aDataToRet[sEntityName]['ctrlType'] = aItem.ctrlType;
                            break;
                    }
                }
            }
            else
            {
                aDataToRet[sEntityName] = JsonTreeDataCreator.getNotebookSection(aItem)
            }
        }
        return aDataToRet;
    }

    /**
     * Super notebook containing all model types/objects notebooks
     * @param {String} sDataType 
     */
    static superNotebookData = (sDataType, aIds, bNestedData, bRepoObjOnly) =>
    {
        if (!sDataType)
        {
            return null;
        }
        var aSuperNotebook = {};
        var aMetaData = {};
        try
        {
            switch (sDataType)
            {
                case ('modeltypes'):
                    if (!aIds)
                    {
                        aMetaData = MetamodelStore.getInstance().getMetaModelTypes();
                    }
                    else
                    {
                        const aMetaDataAll = MetamodelStore.getInstance().getMetaModelTypes();
                        for (let i = 0; i < aIds.length; i++)
                        {
                            aMetaData[aIds[i]] = aMetaDataAll[aIds[i]];
                        }
                    }
                    break;
                case ('objects'):
                    if (!aIds)
                    {
                        aMetaData = MetamodelStore.getInstance().getMetaObjectTypesVisible(false, bRepoObjOnly);
                    }
                    else
                    {
                        const aMetaDataAll = MetamodelStore.getInstance().getMetaObjectTypesVisible(false, bRepoObjOnly);
                        for (let i = 0; i < aIds.length; i++)
                        {
                            aMetaData[aIds[i]] = aMetaDataAll[aIds[i]];
                        }
                    }
                    break;
                default:
                    return null;
            }
        }
        catch (err)
        {
            console.error(err);
            return null;
        }
        const aKeys = Object.keys(aMetaData);
        for (var i = 0; i < aKeys.length; i++)
        {
            const aItem = aMetaData[aKeys[i]];
            if (aItem && Object.hasOwnProperty.call(aItem, 'aDisplayName'))
            {
                var aKey = Config.getLangName(aItem);
                if (aKey)
                {
                    if (Object.hasOwnProperty.call(aItem, 'notebookStructure'))
                    {
                        aSuperNotebook[aKey] = JsonTreeDataCreator.notebookData(aItem.notebookStructure, bNestedData);
                        if (Object.hasOwnProperty.call(aItem, 'id'))
                        {
                            aSuperNotebook[aKey]['id_group'] = aItem.id;
                        }
                    }
                }
            }
        }
        return aSuperNotebook;
    }

    /**
     * Json containing objects of all model types, with or without notebook data
     * @param {Boolean} bNoNotebook 
     */
    static superObjectsData = (bNoNotebook, bNestedData) =>
    {
        var aSuperObjData = {};
        var aMetaData;
        try
        {
            aMetaData = MetamodelStore.getInstance().getMetaModelTypes();
        }
        catch (err)
        {
            console.error(err);
            return null;
        }

        const aKeys = Object.keys(aMetaData);
        for (var i = 0; i < aKeys.length; i++)
        {
            const aItem = aMetaData[aKeys[i]];
            if (aItem && Object.hasOwnProperty.call(aItem, 'aDisplayName'))
            {
                var aKey = Config.getLangName(aItem)
                if (aKey)
                {
                    if (Object.hasOwnProperty.call(aItem, 'classes'))
                    {
                        var aObjectsIds = [];
                        try
                        {
                            var aObjects = MetamodelStore.getObjectsByID(aItem.classes);
                            aObjectsIds = aObjects.map(aObj =>
                            {
                                if (aObj && Object.hasOwnProperty.call(aObj, 'id'))
                                {
                                    return aObj.id;
                                }
                                return null;
                            })
                        }
                        catch (err)
                        {
                            console.error(err);
                        }

                        if (bNoNotebook)
                        {
                            aSuperObjData[aKey] = aObjectsIds;
                            if (Object.hasOwnProperty.call(aItem, 'id'))
                            {
                                aSuperObjData[aKey]['id_group'] = aItem.id;
                            }
                        }
                        else
                        {
                            aSuperObjData[aKey] = JsonTreeDataCreator.objectsData(aObjectsIds, true, bNestedData);
                            if (Object.hasOwnProperty.call(aItem, 'id'))
                            {
                                aSuperObjData[aKey]['id_group'] = aItem.id;
                            }
                        }
                    }
                }
            }
        }
        return aSuperObjData;
    }

    static queriesTree = (aData) =>
    {
        if (!aData)
        {
            return null;
        }
        let aQueries = {};
        aQueries[Config.strings.jsonTree.queries.topLabel] = {
            id: uuidv4()
        };
        if (!aData.hasOwnProperty("items") || !(aData.items.length && 0 < aData.items.length))
        {
            return {};
        }
        aData.items.forEach(aItem =>
        {
            if (aItem.hasOwnProperty("name") && aItem.hasOwnProperty("id") && aItem.name && aItem.id)
            {
                aQueries[Config.strings.jsonTree.queries.topLabel][aItem.name] = {
                    id: aItem.id,
                    isEntity: true
                };
            }
        });
        return aQueries;
    }

    static entitiesGroupTree = (aData, bPreventImmerse, bIncludeRoot) =>
    {
        if (!aData)
        {
            return null;
        }

        let aJsonData = {};

        const sortingFn = (aContainer, aA, aB) =>
        {
            if (!aContainer[aA].isEntity && aContainer[aB].isEntity)
            {
                return -1;
            }
            else if (aContainer[aA].isEntity && !aContainer[aB].isEntity)
            {
                return 1
            }
            let aAtoLC = aA.toLowerCase();
            let aBtoLC = aB.toLowerCase();
            if (aAtoLC < aBtoLC)
            {
                return -1;
            }
            else if (aAtoLC > aBtoLC)
            {
                return 1;
            }
            return 0;
        }

        const getEntityData = (aEntity) =>
        {
            if (aEntity && aEntity.hasOwnProperty("id") && aEntity.id && aEntity.hasOwnProperty("name") && aEntity.name)
            {
                let sIconUrl = null;
                if (aEntity.hasOwnProperty("icon") && aEntity.icon.hasOwnProperty("href"))
                {
                    sIconUrl = aEntity.icon.href;
                    let sReqUrl;
                    if(isBasicAuth()){
                        sReqUrl = Config.requestDirect.concat("?url=", sIconUrl, "&dataType=img");
                    }else{
                        sReqUrl = sIconUrl+"?dataType=img";
                    }
                    DataCache.getInstance().setItem(
                        {
                            url: sIconUrl,
                            response: sReqUrl
                        });
                }
                return {
                    id: aEntity.id,
                    name: aEntity.name,
                    iconUrl: sIconUrl ? sIconUrl : null
                };
            }
            return null;
        }

        const getObjectAttributes = (aObj,attr) => {
            const attribute = aObj?.attributes?.find(item => item.name === attr);
            return attribute ? attribute.value : "";
        }

        const getGroupEntities = (aGroup, aContainer) =>
        {

            if (aGroup.hasOwnProperty("objects") && Array.isArray(aGroup.objects) && 0 < aGroup.objects.length)
            {
                aGroup.objects.forEach(aObj =>
                {
                    let sObjectVersion = getObjectAttributes(aObj,"Version")
                    let aData = getEntityData(aObj);
                    
                    if (aData)
                    {
                        if(sObjectVersion.length !== 0){
                            aContainer[aData.name +' '+ sObjectVersion] = {
                                id: aData.id,
                                isEntity: true,
                                iconUrl: aData.iconUrl
                            }
                        }else{
                            aContainer[aData.name] = {
                                id: aData.id,
                                isEntity: true,
                                iconUrl: aData.iconUrl
                            }
                        }  
                    }
                });
            }
            if (aGroup.hasOwnProperty("models") && Array.isArray(aGroup.models) && 0 < aGroup.models.length)
            {
                aGroup.models.forEach(aObj =>
                {
                    let aData = getEntityData(aObj);
                    if (aData)
                    {
                        aContainer[aData.name] = {
                            id: aData.id,
                            isEntity: true,
                            iconUrl: aData.iconUrl
                        }
                    }
                });
            }

            return Object.keys(aContainer).sort((aA, aB) =>
            {
                return sortingFn(aContainer, aA, aB)
            }).reduce(
                (aObj, sKey) =>
                {
                    aObj[sKey] = aContainer[sKey];
                    return aObj;
                },
                {}
            );
        }

        const getGroupSubgroup = (aGroup, aContainer) =>
        {
            if (aGroup.hasOwnProperty("subgroups") && Array.isArray(aGroup.subgroups) && 0 < aGroup.subgroups.length)
            {
                aGroup.subgroups.forEach(aSubgroup =>
                {
                    let aSubgroupData = getEntityData(aSubgroup);
                    if (aSubgroupData)
                    {
                        aContainer[aSubgroupData.name] = {
                            id: aSubgroupData.id,
                            isEntity: false
                        };
                        if (!bPreventImmerse)
                        {
                            aContainer[aSubgroupData.name] = getGroupEntities(aSubgroup, aContainer[aSubgroupData.name]);
                            aContainer[aSubgroupData.name] = getGroupSubgroup(aSubgroup, aContainer[aSubgroupData.name]);
                        }
                    }
                })
            }

            return Object.keys(aContainer).sort((aA, aB) =>
            {
                return sortingFn(aContainer, aA, aB)
            }).reduce(
                (aObj, sKey) =>
                {
                    aObj[sKey] = aContainer[sKey];
                    return aObj;
                },
                {}
            );
        }

        if (aData.hasOwnProperty("group"))
        {
            if (bIncludeRoot)
            {
                let aTopGroupData = getEntityData(aData.group);
                if (aTopGroupData)
                {
                    aJsonData[aTopGroupData.name] = {
                        id: aTopGroupData.id,
                        isEntity: false
                    };
                }
                aJsonData[aTopGroupData.name] = getGroupEntities(aData.group, aJsonData[aTopGroupData.name]);
                aJsonData[aTopGroupData.name] = getGroupSubgroup(aData.group, aJsonData[aTopGroupData.name]);
            }
            else
            {
                aJsonData = getGroupEntities(aData.group, aJsonData);
                aJsonData = getGroupSubgroup(aData.group, aJsonData);
            }
        }

        return aJsonData;
    }
}